import PickupType from "../../enums/PickupType";
import Game from "../Game";
import GameCore from "../GameCore";
import BasePickup from "./BasePickup";
import PickupGroup from "./PickupGroup";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class VacuumPickup extends BasePickup {
  constructor(group: PickupGroup, x: number, y: number) {
    super(group, x, y, PickupType.VACUUM, SPRITESHEET_KEYS.PICKUPS);
    this.setTexture(
      SPRITESHEET_KEYS.PICKUPS,
      SPRITESHEET_FRAMES.PICKUPS.MAGNET_PICKUP
    );
    this.scene.add.existing(this);
    this.setScale(GameCore.PixelScale);
  }

  OnRecycle() {
    super.OnRecycle();
    this.setTexture(
      SPRITESHEET_KEYS.PICKUPS,
      SPRITESHEET_FRAMES.PICKUPS.MAGNET_PICKUP
    );
  }

  Update(): void {
    super.Update();
    this.setDepth(this.y - Game.Core.Player.y);
  }
  GetTaken() {
    Game.Core.TurnOnVacuum();
    this.SetSeenItem(this.itemType);
    super.GetTaken();
  }
}
